import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { Platform } from '../api/models/platform';

@Directive({
  selector: '[platformIcon]',
  standalone: true,
})
export class PlatformIconDirective implements OnInit {
  @Input('platformIcon') platform: Platform;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi  mdi-26px ';

    switch (this.platform) {
      case Platform.Windows:
        classList +=
          'mdi-microsoft-windows tw-text-blue-600 dark:tw-text-blue-400';
        break;

      case Platform.iOS:
        classList += 'mdi-apple-ios tw-text-gray-800 dark:tw-text-gray-400';
        break;

      case Platform.Android:
        classList += 'mdi-android tw-text-green-600 dark:tw-text-green-400';
        break;

      case Platform.Linux:
        classList += 'mdi-linux tw-text-black dark:tw-text-gray-600';
        break;

      case Platform.Mac:
        classList += 'mdi-apple tw-text-gray-700 dark:tw-text-gray-500';
        break;

      case Platform.iPadOS:
        classList += 'mdi-ipod tw-text-red-600 dark:tw-text-red-500';
        break;
      case Platform.ChromeOS:
        classList +=
          'mdi-google-chrome tw-text-yellow-600 dark:tw-text-yellow-500'; // ChromeOS
        break;

      case Platform.Others:
        classList += 'mdi-web tw-text-gray-600 dark:tw-text-gray-500'; // Others
        break;

      case Platform.Unknown:
        classList +=
          'mdi-help-circle-outline tw-text-gray-400 tw-opacity-70 mdi-22px'; // Unknown
        break;
      default:
        classList += 'mdi-device-hub tw-text-gray-600 dark:tw-text-gray-500'; // رنگ پیش‌فرض
        break;
    }

    return classList;
  }
}
